import Api from '../Base'

class PostSpaceInstance extends Api {
  requestUrl = `/api/spaceInstance`

  method = 'POST'
}

export default PostSpaceInstance
